import { useState } from 'react';

export type ConfirmationProps = {};

export type ConfirmationState<Name, Params extends unknown> = {
  isOpen: boolean;
  name: Name | null;
  params: Params | null;
};
export type ConfirmationResult<Name, Params extends unknown> = {
  state: ConfirmationState<Name, Params>;
  open(name: Name, params?: Params | null): void;
  close(): void;
};

const useBottomSheet = <Name extends string, Params extends unknown = {}>(
  props: ConfirmationProps = {}
): ConfirmationResult<Name, Params> => {
  const [state, setState] = useState<ConfirmationState<Name, Params>>({
    isOpen: false,
    name: null,
    params: null
  });

  const open = (name: Name, params: Params | null = null) => {
    setState({ isOpen: true, name, params });
  };

  const close = () => {
    setState(() => ({ isOpen: false, name: null, params: null }));
  };

  return { state, open, close };
};

export default useBottomSheet;
